<template>
  <div class="new-booking">
    <page-header
      title="Edit Booking"
      breadcrumb="Dashboard > Bookings > Edit Booking"
    />
    <div class="card">
      <div class="booking-steps">
        <div
          class="booking-step "
          :class="{ current: formNo == 1, done: formNo > 1 }"
        >
          <div class="booking-step__icon">
            <span v-if="formNo > 1"><check-mark /></span> <span v-else>1</span>
          </div>
          <span class="booking-step__title">Shipper</span>
        </div>
        <div
          class="booking-step cursor-pointer"
          :class="{ current: formNo == 2, done: true }" @click="formNo = 2"
        >
          <div class="booking-step__icon">
            <span v-if="formNo > 2"><check-mark /></span> <span v-else>2</span>
          </div>
          <span class="booking-step__title">Consignee</span>
        </div>
        <div
          class="booking-step"
          :class="{ current: formNo == 3, done: true }"
        >
          <div class="booking-step__icon">
            <span v-if="formNo > 3"><check-mark /></span> <span v-else>3</span>
          </div>
          <span class="booking-step__title">Package</span>
        </div>
        <div
          class="booking-step"
          :class="{ current: formNo == 4, done: true }"
        >
          <div class="booking-step__icon">
            <span v-if="formNo > 4"><check-mark /></span> <span v-else>4</span>
          </div>
          <span class="booking-step__title">Shipping</span>
        </div>
        <div
          class="booking-step"
          :class="{ current: formNo == 5, done: true }"
        >
          <div class="booking-step__icon">
            <span v-if="formNo > 5"><check-mark /></span> <span v-else>5</span>
          </div>
          <span class="booking-step__title">Review</span>
        </div>
        <div
          class="booking-step"
          :class="{ current: formNo == 6, done: formNo > 6 }"
        >
          <div class="booking-step__icon">
            <span v-if="formNo > 6"><check-mark /></span> <span v-else>6</span>
          </div>
          <span class="booking-step__title">Payment</span>
        </div>
      </div>
      
      <keep-alive>
        <component
          :is="currentForm"
          @change-form="formNo++"
          @back-one-form="formNo--"
          @add-new-consignee="formNo = 2"
        ></component>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import ShipperForm from "./ShipperForm";
import ConsigneeForm from "./ConsigneeForm";
import PackageForm from "./PackageForm";
import ShippingDetailsForm from "./ShippingDetailsForm";
import BookingReview from "./BookingReview";
import PaymentForm from "./PaymentForm";
import CheckMark from "./CheckmarkSvg";
import PageHeader from "@/components/UI/NewPageHeader";
export default {
  components: {
    ShipperForm,
    ConsigneeForm,
    PackageForm,
    ShippingDetailsForm,
    BookingReview,
    PaymentForm,
    CheckMark,
    PageHeader,
  },
  data() {
    return {
      formNo: 1,
    };
  },
  computed: {
    currentForm() {
      if (this.formNo == 1) {
        return "shipper-form";
      } else if (this.formNo == 2) {
        return "consignee-form";
      } else if (this.formNo == 3) {
        return "package-form";
      } else if (this.formNo == 4) {
        return "shipping-details-form";
      } else if (this.formNo == 5) {
        return "booking-review";
      } else {
        return "payment-form";
      }
    },
  },
  watch: {
    formNo() {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0;
    },
  },
  mounted() {
    if (this.$store.getters.lastCompletedFormNo) {
      this.formNo = this.$store.getters.lastCompletedFormNo + 1;
    }
    
  },
  methods: {
    async createUser() {
      try {
        const response = await this.$_createOndemandUser();

        localStorage.setItem("userIdForBookings", response.data.data.user.id);
      } catch (error) {
        this.handleError();
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.card {
  padding: 0;
}
.new-booking {
  --grey: #b7c1cc;
  --amber: #f7b643;
  // margin-bottom: 3rem;
}

.booking-steps {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  background: #fffcf7;
  padding: 1rem 5rem;
}
.booking-step.current,
.booking-step.done {
  .booking-step__icon {
    background: var(--amber);
  }
  .booking-step__title {
    font-weight: 500;
  }
}
.booking-step__icon {
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 50%;
  background: var(--grey);
  margin: 0.5rem auto;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
}
.booking-step__title {
  color: var(--primaryblue);
  font-size: 0.9rem;
}

.label {
  color: var(-primaryblue);
  font-size: 0.9rem;
  font-weight: 500;
}

.button {
  background-color: #fcc210;
  color: var(--primaryblue);
  border: 1px solid #fcc008;
  box-sizing: border-box;
  box-shadow: 0px 6px 10px rgba(221, 144, 9, 0.25);
  border-radius: 2px;
  margin-right: 1.5rem;
}
</style>
